import * as React from 'react';
import { styled } from '@mui/system';
import { Link } from 'gatsby'
import MUILink from '@mui/material/Link';


import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { Stack, ListItem } from '@mui/material';

// @material-ui/icons
import Favorite from '@mui/icons-material/Favorite';

// import footerStyle from 'assets/jss/aleign/components/footerStyle.jsx';

const FooterWrap = styled(Box)({
	padding: '0.9375rem 0',
	textAlign: 'center',
	display: 'flex',
	zIndex: '2',
	position: 'relative',
	// borderTop: '1px solid',
	// marginTop: '100px',
});

const FooterContainer = styled(Box)({
	paddingRight: '15px',
	paddingLeft: '15px',
	marginRight: 'auto',
	marginLeft: 'auto',
	width: '100%',
});

const Block = styled(Box)({
	color: '#ffffff',
	padding: '0 0.9375rem',
	fontWeight: '500',
	fontSize: '12px',
	textTransform: 'uppercase',
	borderRadius: '3px',
	textDecoration: 'none',
	position: 'relative',
	display: 'block',
	lineHeight: 1.6
});

function Footer() {
	return (
		<FooterWrap>
			<FooterContainer>
				<Stack
					direction='row'
					justifyContent='center'
					alignItems='center'
					spacing={2}
					py={2}
					sx={{'.MuiLink-root': {fontSize:'14px', cursor: 'pointer'}}}
				>
					<MUILink component={Link} to='/#AboutV2' >
						Who / What
					</MUILink>
					<MUILink component={Link} to='/#toolBox' >
						The Toolbox
					</MUILink>
					<MUILink component={Link} to='/get-in-touch' >
						Signup / Login
					</MUILink>		
					<MUILink onClick={() => window.FreshworksWidget('open')}>
						Contact
					</MUILink>
					<MUILink component={Link} to='/terms-conditions' >
						Terms and Conditions
					</MUILink>
					<MUILink component={Link} to='/privacy' >
						Privacy
					</MUILink>
				</Stack>
				<Block>
					<b>ECM CANBERRA:</b> JAGA Swanson Court Level 1, 11-17 Swanson Court,
					Belconnen ACT 2617
					<br />
					<b>ECM MELBOURNE:</b> Melbourne VIC 3199
					<br />
					<b>WCM PERTH:</b> Perth WA 6006
				</Block>
				
				<Block>
					All Rights Reserved. &copy; {1900 + new Date().getYear()} | Aleign&reg; PTY
					LTD | made with{' '}
					<Favorite
						sx={{ width: '18px', height: '18px', position: 'relative', top: '3px' }}
					/>{' '}
					for a brave nu web.
				</Block>
				{/* <Block>
					<a href="terms-and-conditions">Terms and Conditions</a><a href="privacy.htm">Privacy Policy</a>
				</Block> */}
			</FooterContainer>
		</FooterWrap>
	);
}

export default Footer;
